export const actions = {
  TABU_YASHIR_SING_IN: 'TABU_YASHIR_SING_IN',
  TABU_YASHIR_SING_IN_SUCCESS: 'TABU_YASHIR_SING_IN_SUCCESS',
  TABU_YASHIR_SING_IN_FAILURE: 'TABU_YASHIR_SING_IN_FAILURE',
  GET_SHUMA_STEPS_STATUS: 'GET_SHUMA_STEPS_STATUS',
  GET_SHUMA_STEPS_STATUS_SUCCESS: 'GET_SHUMA_STEPS_STATUS_SUCCESS',
  GET_SHUMA_STEPS_STATUS_FAILURE: 'GET_SHUMA_STEPS_STATUS_FAILURE',
  GET_SHUMA_STEP_DATA: 'GET_SHUMA_STEP_DATA',
  GET_SHUMA_STEP_DATA_SUCCESS: 'GET_SHUMA_STEP_DATA_SUCCESS',
  GET_SHUMA_STEP_DATA_FAILURE: 'GET_SHUMA_STEP_DATA_FAILURE',
  APPEND_SHUMA_STEP_DATA: 'APPEND_SHUMA_STEP_DATA',
  GET_STEP_DATA: 'GET_STEP_DATA',
  GET_STEP_DATA_SUCCESS: 'GET_STEP_DATA_SUCCESS',
  GET_STEP_DATA_FAILURE: 'GET_STEP_DATA_FAILURE',
  GET_CITIES: 'GET_CITIES',
  GET_CITIES_SUCCESS: 'GET_CITIES_SUCCESS',
  GET_CITIES_FAILURE: 'GET_CITIES_FAILURE',
  GET_TAB_CITIES: 'GET_TAB_CITIES',
  GET_TAB_CITIES_SUCCESS: 'GET_TAB_CITIES_SUCCESS',
  GET_TAB_CITIES_FAILURE: 'GET_TAB_CITIES_FAILURE',
  GET_STREETS: 'GET_STREETS',
  GET_STREETS_SUCCESS: 'GET_STREETS_SUCCESS',
  GET_STREETS_FAILURE: 'GET_STREETS_FAILURE',
  GET_TAB_STREETS: 'GET_TAB_STREETS',
  GET_TAB_STREETS_SUCCESS: 'GET_TAB_STREETS_SUCCESS',
  GET_TAB_STREETS_FAILURE: 'GET_TAB_STREETS_FAILURE',
  GET_STEP_9_GIRD_FIRM_DATA: 'GET_STEP_9_GIRD_FIRM_DATA',
  GET_STEP_9_GIRD_FIRM_DATA_SUCCESS: 'GET_STEP_9_GIRD_FIRM_DATA_SUCCESS',
  GET_STEP_9_GIRD_FIRM_DATA_FAILURE: 'GET_STEP_9_GIRD_FIRM_DATA_FAILURE',
  SET_STEP_9_GIRD_FIRM_DATA_PAGE: 'SET_STEP_9_GIRD_FIRM_DATA_PAGE',
  GET_STEP_9_GRID_FIRM_DATA_FOR_EXCEL: 'GET_STEP_9_GRID_FIRM_DATA_FOR_EXCEL',
  GET_STEP_9_GRID_FIRM_DATA_FOR_EXCEL_SUCCESS: 'GET_STEP_9_GRID_FIRM_DATA_FOR_EXCEL_SUCCESS',
  GET_STEP_9_GRID_FIRM_DATA_FOR_EXCEL_FAILURE: 'GET_STEP_9_GRID_FIRM_DATA_FOR_EXCEL_FAILURE',
  GET_STEP_9_GIRD_SHARED_DATA: 'GET_STEP_9_GIRD_SHARED_DATA',
  GET_STEP_9_GIRD_SHARED_DATA_SUCCESS: 'GET_STEP_9_GIRD_SHARED_DATA_SUCCESS',
  GET_STEP_9_GIRD_SHARED_DATA_FAILURE: 'GET_STEP_9_GIRD_SHARED_DATA_FAILURE',
  SET_STEP_9_GIRD_SHARED_DATA_PAGE: 'SET_STEP_9_GIRD_SHARED_DATA_PAGE',
  GET_STEP_9_GRID_SHARED_DATA_FOR_EXCEL: 'GET_STEP_9_GRID_SHARED_DATA_FOR_EXCEL',
  GET_STEP_9_GRID_SHARED_DATA_FOR_EXCEL_SUCCESS: 'GET_STEP_9_GRID_SHARED_DATA_FOR_EXCEL_SUCCESS',
  GET_STEP_9_GRID_SHARED_DATA_FOR_EXCEL_FAILURE: 'GET_STEP_9_GRID_SHARED_DATA_FOR_EXCEL_FAILURE',
  GET_STEP_9_GIRD_SIMILAR_ASSETS: 'GET_STEP_9_GIRD_SIMILAR_ASSETS',
  GET_STEP_9_GIRD_SIMILAR_ASSETS_SUCCESS: 'GET_STEP_9_GIRD_SIMILAR_ASSETS_SUCCESS',
  GET_STEP_9_GIRD_SIMILAR_ASSETS_FAILURE: 'GET_STEP_9_GIRD_SIMILAR_ASSETS_FAILURE',
  SET_STEP_9_GIRD_SIMILAR_ASSETS_PAGE: 'SET_STEP_9_GIRD_SIMILAR_ASSETS_PAGE',
  GET_STEP_9_GRID_SIMILAR_ASSETS_FOR_EXCEL: 'GET_STEP_9_GRID_SIMILAR_ASSETS_FOR_EXCEL',
  GET_STEP_9_GRID_SIMILAR_ASSETS_FOR_EXCEL_SUCCESS: 'GET_STEP_9_GRID_SIMILAR_ASSETS_FOR_EXCEL_SUCCESS',
  GET_STEP_9_GRID_SIMILAR_ASSETS_FOR_EXCEL_FAILURE: 'GET_STEP_9_GRID_SIMILAR_ASSETS_FOR_EXCEL_FAILURE',
  GET_STEP_9_GIRD_TAX_AUTHORITY: 'GET_STEP_9_GIRD_TAX_AUTHORITY',
  GET_STEP_9_GIRD_TAX_AUTHORITY_SUCCESS: 'GET_STEP_9_GIRD_TAX_AUTHORITY_SUCCESS',
  GET_STEP_9_GIRD_TAX_AUTHORITY_FAILURE: 'GET_STEP_9_GIRD_TAX_AUTHORITY_FAILURE',
  SET_STEP_9_GIRD_TAX_AUTHORITY_PAGE: 'SET_STEP_9_GIRD_TAX_AUTHORITY_PAGE',
  GET_STEP_9_GRID_TAX_AUTHORITY_FOR_EXCEL: 'GET_STEP_9_GRID_TAX_AUTHORITY_FOR_EXCEL',
  GET_STEP_9_GRID_TAX_AUTHORITY_FOR_EXCEL_SUCCESS: 'GET_STEP_9_GRID_TAX_AUTHORITY_FOR_EXCEL_SUCCESS',
  GET_STEP_9_GRID_TAX_AUTHORITY_FOR_EXCEL_FAILURE: 'GET_STEP_9_GRID_TAX_AUTHORITY_FOR_EXCEL_FAILURE',

  GET_STEP_9_SAVED_ROWS: 'GET_STEP_9_SAVED_ROWS',
  GET_STEP_9_SAVED_ROWS_SUCCESS: 'GET_STEP_9_SAVED_ROWS_SUCCESS',
  GET_STEP_9_SAVED_ROWS_FAILURE: 'GET_STEP_9_SAVED_ROWS_FAILURE',

  SET_STEP_9_GIRD_SAVED_DATA_PAGE: 'SET_STEP_9_GIRD_SAVED_DATA_PAGE',

  SET_STEP_9_GRID_SAVED_COLUMNS: 'SET_STEP_9_GRID_SAVED_COLUMNS',
  GET_STEP_9_GIRD_SAVED_DATA_FAILURE: 'GET_STEP_9_GIRD_SAVED_DATA_FAILURE',
  UPDATE_STEP_9_GRID_SAVED_COLUMN: 'UPDATE_STEP_9_GRID_SAVED_COLUMN',

  GET_STEP_11_FILE_LIST: 'GET_STEP_11_FILE_LIST',
  GET_STEP_11_FILE_LIST_SUCCESS: 'GET_STEP_11_FILE_LIST_SUCCESS',
  GET_STEP_11_FILE_LIST_FAILURE: 'GET_STEP_11_FILE_LIST_FAILURE',
  UPDATE_STEP_9_GRID_SAVED_COLUMNS: 'UPDATE_STEP_9_GRID_SAVED_COLUMNS',
  SHOW_LITTLE_POPUP: 'SHOW_LITTLE_POPUP',
  HIDE_LITTLE_POPUP: 'HIDE_LITTLE_POPUP',
  CLEAR_INSPECTION: 'CLEAR_INSPECTION',
  UPDATE_CUSTOMERS: 'UPDATE_CUSTOMERS',
  SAVE_TAB_1_FILTERS: 'SAVE_TAB_1_FILTERS',
  SAVE_TAB_2_FILTERS: 'SAVE_TAB_2_FILTERS',
  SAVE_TAB_3_FILTERS: 'SAVE_TAB_3_FILTERS',
  SAVE_TAB_4_VALUES: 'SAVE_TAB_4_VALUES',
  SET_SHUMA_PROPERTIES: 'SET_SHUMA_PROPERTIES',
  GET_SHUMA_PROPERTIES: 'GET_SHUMA_PROPERTIES',
  GET_SHUMA_PROPERTIES_SUCCESS: 'GET_SHUMA_PROPERTIES_SUCCESS',
  GET_SHUMA_PROPERTIES_FAILURE: 'GET_SHUMA_PROPERTIES_FAILURE',
  SET_SHUMA_STATUS_TYPE_ID: 'SET_SHUMA_STATUS_TYPE_ID',
};

